import PropTypes from "prop-types";
import React from "react";
import { multilanguage } from "redux-multilanguage";
import { connect } from "react-redux";
import { setCurrency } from "../../redux/actions/currencyActions";
import LanguageChanger from "./sub-components/LanguageChanger";
import { fetchProducts } from "../../redux/actions/productActions";

const HeaderTop = ({
  currency,
  setCurrency,
  fetchProducts,
  currentLanguageCode,
  dispatch,
  borderStyle,
  strings
}) => {
  return (
    <div
      className={`header-top-wap ${
        borderStyle === "fluid-border" ? "border-bottom" : ""
      }`}
    >
      <LanguageChanger
        currency={currency}
        setCurrency={setCurrency}
        fetchProducts={fetchProducts}
        currentLanguageCode={currentLanguageCode}
        dispatch={dispatch}
      />
    {/*  <div className="header-offer">
        <p>
          {strings["free_delivery_over"]}
        </p>
    </div>  */}
    </div>
  );
};

HeaderTop.propTypes = {
  borderStyle: PropTypes.string,
  setCurrency: PropTypes.func,
  fetchProducts: PropTypes.func,
  currency: PropTypes.object,
  currentLanguageCode: PropTypes.string,
  dispatch: PropTypes.func
};

const mapStateToProps = state => {
  return {
    currency: state.currencyData,
    products: state.productData
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setCurrency: currencyName => {
      dispatch(setCurrency(currencyName));
    },
    fetchProducts: products => {
      dispatch(fetchProducts(products));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(multilanguage(HeaderTop));
